export const DELIVERY_OPTION_CODES = {
  SAME_DAY: 'same_day_delivery',
  NEXT_DAY: 'next_day_delivery',
  SINGPOST_FREE_UP_TO_4_DAYS: 'singpost_free_up_to_4_days',
  SINGPOST_TRACKED_LETTERBOX: 'singpost_tracked_letterbox',
};

const normalizeName = value =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&amp;/g, 'and')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const toSlug = value =>
  normalizeName(value)
    .replace(/\s+/g, '_')
    .replace(/^_+|_+$/g, '');

export function getDeliveryOptionCode(option) {
  if (!option) return '';
  if (typeof option === 'string') return getDeliveryOptionCode({ name: option });
  if (option.code) return option.code;
  if (option.deliveryCode) return option.deliveryCode;

  const name = normalizeName(option.name || option.option || option.shippingOption);
  if (!name && option.drupal_id) return `drupal_${option.drupal_id}`;
  if (!name && option.id) return `delivery_${option.id}`;

  if (name.includes('same day')) {
    return DELIVERY_OPTION_CODES.SAME_DAY;
  }
  if (name.includes('next day')) {
    return DELIVERY_OPTION_CODES.NEXT_DAY;
  }
  if (name.includes('singpost') && name.includes('up to 4 days')) {
    return DELIVERY_OPTION_CODES.SINGPOST_FREE_UP_TO_4_DAYS;
  }
  if (name.includes('singpost') && (name.includes('letterbox') || name.includes('tracked'))) {
    return DELIVERY_OPTION_CODES.SINGPOST_TRACKED_LETTERBOX;
  }

  return toSlug(name) || `delivery_${option.drupal_id || option.id || 'unknown'}`;
}

export function hasValidDeliveryOption(option) {
  const code = getDeliveryOptionCode(option);
  const name = typeof option === 'string'
    ? option
    : option?.name || option?.option || option?.shippingOption;
  const normalized = normalizeName(name);
  return Boolean(code && normalized && normalized !== 'none');
}

export function getDeliveryOptionKey(option) {
  if (!option) return '';
  return String(option.drupal_id || option.id || getDeliveryOptionCode(option) || option.name || '');
}

export function isSameDeliveryOption(a, b) {
  if (!a || !b) return false;
  const keyA = getDeliveryOptionKey(a);
  const keyB = getDeliveryOptionKey(b);
  if (keyA && keyB && keyA === keyB) return true;
  const codeA = getDeliveryOptionCode(a);
  const codeB = getDeliveryOptionCode(b);
  return Boolean(codeA && codeB && codeA === codeB);
}

export function isCourierDeliveryOption(option) {
  const code = getDeliveryOptionCode(option);
  return (
    code === DELIVERY_OPTION_CODES.SAME_DAY ||
    code === DELIVERY_OPTION_CODES.NEXT_DAY
  );
}
